module.exports = __webpack_public_path__ + "img/Foto_modulo_oficina_virtual.9fd4f6b6.png";